<template lang="pug">
  v-combobox(v-if="!readonly" :label="label" multiple :value="value" chips @input="addTag")
    template(slot="selection" slot-scope="data")
      v-chip(close @input="removeTag(data.index)") {{ data.item }}
  div(v-else-if="value.length")
    v-label {{ label }} {{ readonly ? ': ' : '' }}
    ul
      li(v-for="choice in value") {{ choice }}
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: '',
    },
    value: {
      type: Array,
      default: () => [],
    },
    valueId: {
      type: [Number, String],
      default: null,
    },
    attributeId: {
      type: Number,
      default: null,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleChange(value) {
      if (!value || !value.length) {
        if (this.valueId) {
          this.$emit('delete', this.valueId);
        }
      } else {
        if (!this.valueId) {
          this.$emit('post', {attributeId: this.attributeId, value});
        } else {
          this.$emit('put', {valueId: this.valueId, value});
        }
      }
    },
    addTag(tags) {
      this.handleChange(tags);
    },
    removeTag(idx) {
      const newTags = JSON.parse(JSON.stringify(this.value));
      newTags.splice(idx, 1);
      this.handleChange(newTags);
    },
  },
}
</script>
